import { useCallback, useEffect, useState } from 'react';

const MIN_MAXIMIZE_WIDTH = 700;

const sideNavWidth = (): number => {
  if (window.innerWidth <= MIN_MAXIMIZE_WIDTH) return 0;
  const nav = document.querySelector('nav.main');
  return nav ? Math.round(nav.getBoundingClientRect().width) : 0;
};

export const useMaximizableDrawer = (
  initiallyMaximized = false
): {
  maximized: boolean;
  maximizedOffset: number;
  canMaximize: boolean;
  toggleMaximized: () => void;
} => {
  const [maximized, setMaximized] = useState(initiallyMaximized);
  const [maximizedOffset, setMaximizedOffset] = useState(0);
  const [canMaximize, setCanMaximize] = useState(true);

  useEffect(() => {
    const update = () => {
      const allowed = window.innerWidth > MIN_MAXIMIZE_WIDTH;
      setMaximizedOffset(sideNavWidth());
      setCanMaximize(allowed);
      if (!allowed) setMaximized(false);
    };
    update();
    window.addEventListener('resize', update);
    const nav = document.querySelector('nav.main');
    const observer = nav && window.ResizeObserver ? new window.ResizeObserver(update) : null;
    if (nav && observer) observer.observe(nav);
    return () => {
      window.removeEventListener('resize', update);
      observer?.disconnect();
    };
  }, []);

  const toggleMaximized = useCallback(() => setMaximized((prev) => !prev), []);

  return { maximized: canMaximize && maximized, maximizedOffset, canMaximize, toggleMaximized };
};
